<page-headline
    [linkTitle]="''"
    [module]="pageHeadline.module"
    [moduleIcon]="pageHeadline.moduleIcon"
    [moduleLink]="pageHeadline.moduleLink"
    [pageTitle]="pageHeadline.pageTitle"
    [linkArray]="pageHeadline.linkArray"
>
</page-headline>
<main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
<div class="display-options-action-panel-area">
    <display-options (displayOptionsOutput)="applyDisplayOptions($event)"></display-options>
    <action-panel
        [showExportCsv]="false"
        [showSaveAsPdf]="true"
        [showPrint]="false"
        [title]="pageHeadline.pageTitle"
    >
    </action-panel>
</div>
<div class="radio-years-button-area">
    <mat-radio-group class="mat-radio-years">
        <mat-radio-button
            class="radio-yearOptions"
            *ngFor="let yearOption of yearOptions"
            [value]="yearOption.year"
            (change)="yearChange(yearOption.year)"
            [checked]="yearOption.year.toString() === parameters.year"
        >
            {{ yearOption.year }}
        </mat-radio-button>
    </mat-radio-group>
</div>
<div class="row-layout-track">
    <div class="largecard-layout-box__20pct">
        <div
            *ngFor="let pieChart of pieChartsInfo; let idx = index"
            [ngClass]="{ 'layout-padding-bottom__1_5rem': true }"
        >
            <mat-card class="pie-chart-container">
                <div
                    id="{{ pieChart.id }}"
                    [ngStyle]="{ display: pieChart.hasData ? '' : 'none' }"
                ></div>
                <spin-loader
                    *ngIf="!pieChart.isDataReady"
                    [type]="'spinner'"
                    class="donut-spin-loader"
                ></spin-loader>
                <div class="no-data-message-area" *ngIf="!pieChart.hasData && pieChart.isDataReady">
                    <no-data-screen [noDataType]="noDataTypePieType"></no-data-screen>
                </div>
            </mat-card>
        </div>
    </div>
    <div class="largecard-layout-box__80pct">
        <large-card [largeCardInteriorOptions]="largeCardInteriorOptions"></large-card>
    </div>
</div>
